export const ROUTE_NAMES: Record<string, string> = {
  "/": " ",
  "/go": "Ali Bhtty S.",
  "/mixtape": "MixtapeRadio®",
  "/ajustes": "Ajustes",
  "/insights": "Insights",
  "/dash": "Dashboard",
  "/buscar": "Buscar",
  "/dashplaylist": "Dashboard Playlist",
  "/dashradio": "Horarios de Radio",
  "/dashtags": "Radio Tags",
  "/dasheventos": "Dashboard Eventos",
  "/dashapp": "Dashboard App",
  "/espacios": "Espacios Radio",
  "/library": " ",
  "/radio": "Radio",
  "/offline": "Descargas Offline",
  "/favoritos": "Favoritos",
  "/notificaciones": "Notificaciones",
  "/news": "Noticias",
  "/terms": "Términos y Condiciones",
  "/policy" : "Políticas de Contenido",
  "/djs": "DJs",
  "/filtro": "Géneros",
  "/start": "Bienvenida",
  "/publicar": "Publicar",
  "/subir": "Publicar pistas",
  "/scroll": "Mixtape Radio",
  "/flappy": "Flappy Game",
  "/u": "",
  "/u/custom": "Editar Perfil",
  "/inscripcion": "Inscripciones",
  "/convertir": "Apple Music by Mixtape",
  "/mixes": "Mis Mixes"
}